<template>
  <v-navigation-drawer v-model="drawer" fixed app :width="drawerWidth">
    <v-toolbar color="cedinzorg-blue" dark fixed app class="pa-3">
      <v-toolbar-side-icon
        @click.stop="toggleDrawer"
        class="hidden-sm-and-down"
      ></v-toolbar-side-icon>
      <v-toolbar-title
        ><img
          @click.stop="$router.push({ name: 'home' })"
          src="/img/logo_white.png"
          class="logo-header-white-sidemenu"
          height="60"
      /></v-toolbar-title>
    </v-toolbar>

    <v-list class="margin-top-100 sidebar-menu">
      <v-list-tile to="/">
        <v-list-tile-action>
          <v-icon>home</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Home</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile v-if="loggedIn" to="/my-offers">
        <v-list-tile-action>
          <v-icon>assignment_return</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Mijn aanbod</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile v-if="loggedIn" to="/offers">
        <v-list-tile-action>
          <v-icon>integration_instructions</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Aanbod</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile v-if="loggedIn" to="/my-appointments">
        <v-list-tile-action>
          <v-icon>event</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Zorgplanner</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile v-if="!loggedIn" to="/login">
        <v-list-tile-action>
          <v-icon>vpn_key</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Inloggen</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile to="/page/about">
        <v-list-tile-action>
          <v-icon>info</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Over de ZorgSpot App</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile to="/page/tutorial">
        <v-list-tile-action>
          <v-icon>info</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Hoe werkt de app?</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile v-if="loggedIn" to="/profile">
        <v-list-tile-action>
          <v-icon>account_circle</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Mijn Profiel</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile v-if="loggedIn" to="/logout">
        <v-list-tile-action>
          <v-icon>exit_to_app</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Uitloggen</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile @click="refresh">
        <v-list-tile-action>
          <v-icon>refresh</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Herladen</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-btn
      fixed
      fab
      bottom
      right
      color="dark"
      @click.stop="setDrawer(false)"
      class="hidden-sm-and-up no-border-shadow"
    >
      <v-icon>close</v-icon>
    </v-btn>
  </v-navigation-drawer>
</template>

<script>
import BackendService from "../services/BackendService";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "SideNav",
  computed: {
    drawer: {
      get: function() {
        return this.$store.state.drawer.showDrawer;
      },
      set: function(v) {
        this.setDrawer(v);
      }
    },
    drawerWidth: function() {
      let w = window.innerWidth;
      if (w < 600) {
        // sm breakpoint
        return w;
      } else {
        return 320;
      }
    },
    ...mapState("user", ["loggedIn", "user"])
  },
  methods: {
    refresh() {
      caches.keys().then(function(names) {
        for (let name of names) {
          caches.delete(name);
        }
        window.location.reload(true);
      });
    },
    ...mapActions("drawer", ["setDrawer"])
  }
};
</script>

<style scoped></style>
